"use client";

import React from "react";
import { Facebook, Instagram, Twitter, MapPin, Phone, Mail, Clock } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-32 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="flex flex-col gap-2 text-sm text-muted-foreground font-default">
        <li><Link to="/ServicesPage" className="hover:text-primary transition-colors">Servicios</Link></li>
        <li><Link to="/PortfolioPage" className="hover:text-primary transition-colors">Portafolio</Link></li>
        <li><Link to="/OurEssencePage" className="hover:text-primary transition-colors">Nuestra Esencia</Link></li>
      </ul>;
  }
  return <NavigationMenu viewport={false} className="max-w-full justify-start">
      <NavigationMenuList className="flex-col items-start gap-1 space-x-0">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i} className="w-full">
            <NavigationMenuLink asChild className="w-full justify-start px-2 py-1.5 h-auto text-muted-foreground hover:text-foreground hover:bg-accent/20 font-default text-sm">
              <Link to={item.href || "#"}>{item.label}</Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const socials = [{
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }];
  const paymentMethods = [{
    name: "Visa",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689867/img/rolver_payment_visa.png"
  }, {
    name: "Mastercard",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689867/img/rolver_payment_mastercard.png"
  }, {
    name: "PayPal",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689867/img/rolver_payment_paypal.png"
  }];
  const legalLinks = [{
    label: "Aviso Legal",
    href: "#"
  }, {
    label: "Privacidad",
    href: "#"
  }, {
    label: "Términos",
    href: "#"
  }];
  return <section data-section-id="264807" id="footer" className="bg-background text-foreground pt-16 pb-8 border-t border-white/10">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <WvcLogo className="h-10 w-auto text-foreground" />
            </Link>
            <p className="text-sm text-muted-foreground font-default mb-6 leading-relaxed">
              Rolver Music Productions: Elevando el espíritu a través de la música cristiana e inspiradora. Fe y creatividad en cada producción musical.
            </p>
            <div className="flex gap-2">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <Button key={i} data-index={i} variant="ghost" size="icon" asChild className="rounded-lg hover:bg-primary/20 hover:text-primary text-muted-foreground transition-all duration-500" aria-label={social.label}>
                    <Link to={social.href}>
                      <Icon className="size-5" />
                    </Link>
                  </Button>;
            })}
            </div>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-lg text-foreground mb-6 tracking-wider uppercase">Explorar</h3>
            <MenuProvider menu_id="42">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-lg text-foreground mb-6 tracking-wider uppercase">Contacto</h3>
            <ul className="space-y-4 text-sm text-muted-foreground font-default">
              <li className="flex items-start gap-3">
                <MapPin className="size-5 mt-0.5 shrink-0 text-secondary" />
                <span>Estudio Central, Ciudad de Producción, Staunton, VA 24401 USA</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="size-5 shrink-0 text-secondary" />
                <span>+1 (540) 421-5105</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="size-5 shrink-0 text-secondary" />
                <span>info@rolvermusicproductions.com</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="size-5 mt-0.5 shrink-0 text-secondary" />
                <span>Lun - Vie: 9:00 - 18:00</span>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-lg text-foreground mb-6 tracking-wider uppercase">Pagos Seguros</h3>
            <p className="text-sm text-muted-foreground font-default mb-4">
              Aceptamos diversas formas de pago para facilitar tu proyecto musical.
            </p>
            <div className="flex flex-wrap gap-3">
              {paymentMethods.map((method, i) => <div key={i} data-index={i} className="bg-card p-2 rounded-md border border-white/10 shadow-md flex items-center justify-center h-10 w-16 backdrop-blur-xl">
                  <img src={method.src} alt={`Pago con ${method.name}`} className="max-h-full max-w-full object-contain" data-wvc-srcset={`${method.src}-wvc-srcset`} data-wvc-sizes={`${method.src}-wvc-sizes`} loading="lazy" />
                </div>)}
            </div>
          </div>

        </div>

        <Separator className="my-8 bg-white/10" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-muted-foreground font-default">
          <p>© 2026 Rolver Music Productions, LLC. Inspiración y Fe.</p>
          <ul className="flex flex-wrap items-center gap-4 md:gap-6">
            {legalLinks.map((link, i) => <li key={i} data-index={i}>
                <Link to={link.href} className="hover:text-secondary transition-colors">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}